<template>
	<div class="log-page  page-padding-top">
    <top-bar :title="i18n.t('assestLog.title')" @back="back" ></top-bar>

    <!-- <div class="filter-line flex">
      <div class="flex-center option" @click="changeTab(1)" :class="tabIndex == 1 ? 'active' : ''">
        <span>{{$t('assestLog.label1')}}</span>
      </div>
      <div class="flex-center option" @click="changeTab(2)" :class="tabIndex == 2 ? 'active' : ''">
        <span>{{$t('assestLog.label2')}}</span>
      </div>

    </div> -->

    <div class="list-main">
      <List
        v-if="dataList.length > 0"
        v-model="loading"
        :finished="finished"
        :finished-text="i18n.t('common.noMore')"
        @load="onLoad">
        <div class="list flex-center" v-for="(item, i) in dataList" :key="i" @click="toDetail(item)">
          <div class="flex-1 flex-center-between">
            <div>
              <div class="label">{{getTypeName(item, item.Currency.ShortName) }}</div>
              <div class="time">{{item.CreatedAt}}</div>
            </div>
            <div>
              <div class="count">{{item.Practical > 0 ? '+' : '-'}}{{formatAmountDisplay(item.Practical)}}</div>
              <div class="status success" v-show="false">{{i18n.t('assestLog.status')}}</div>
            </div>
          </div>
        </div>
      </List>

      <div class="empty flex-column-center" v-if="dataList.length == 0">
        <img :src="emptyUrl" alt="">
        <span class="desc">{{i18n.t('common.empty')}}</span>
      </div>
    </div>

	</div>
</template>
<script>
import { debtType, debtLog, transferRecordLists } from '@/api/assest'
import { getCoinList } from '@/api/index'
import topBar from '@/components/topBar'
import { List } from 'vant'
import { formatAmount } from '@/utils/common'
export default {
  components: {
    topBar,
    List
  },
  data() {
		return {
      form: {
        bit: '',
        type: '4',
        account: ''
      },
      tabIndex: 1,
      page: {
        page: 1,
        limit: 20
      },
      isInit: false,
      loading: false,
      finished: false,
      totalPage: 1,
      bitName: this.i18n.t('assestLog.option1'),
      typeName: this.i18n.t('assestLog.option2'),
      accountName: this.i18n.t('assestLog.option11'),
			backUrl: require('../../assets/imgs/icon-back.png'),
			emptyUrl: require('../../assets/imgs/order-empty.png'),
			downUrl: require('../../assets/imgs/icon-arrow-down3.png'),
			upUrl: require('../../assets/imgs/icon-arrow-up.png'),
			rightUrl: require('../../assets/imgs/icon-arrow-right.png'),
      dataList: [],
      showBitOption: false,
      showTypeOption: false,
      showAccountOption: false,
      typeList: [],
      pageType: ''
		}
	},
  computed: {
  },
  mounted() {
    this.pageType = this.$route.query.type
    this.initType()
  },
	methods: {
    // 格式化金额显示 - 包装utils中的formatAmount函数
    formatAmountDisplay(amount) {
      return formatAmount(amount)
    },
    onLoad() {
      this.page.page += 1
      this.init(true)
    },
    initType() {
      debtType().then(res => {
        let data = res.data
        let list = [ ]
        for (let key in data) {
          let param = {
            value: key,
            label: data[key]
          }
          list.push(param)
        }
        this.typeList = list
        this.init()
      })
    },
    init(isAdd) {
      // 如果是划转记录页面，使用新的API
      if (this.pageType === 'transfer') {
        this.initTransferLog(isAdd)
        return
      }

      let form = new FormData()
      let type = ''
      let multiType = ''
      // switch (this.pageType + '') {
      //   case '1': type = 'Option'; multiType = '2,3,9,10,11'; break;
      //   case '2': type = 'Contract'; multiType = '2,3,12,13,14,15,21,22,23,24,25'; break;
      //   case '3': type = 'Spot'; multiType = ''; break;
      //   case '4': type = 'Finance'; multiType = '2,3,5,16,33'; break;
      //   case '5': type = 'Capital'; multiType = '4,31,32,2,3'; break;
      //   case '6': type = 'Follow'; multiType = '2,3,9,10,11,12,13,14,15,21,22,23,24,25'; break; // 跟单
      //   default: break;
      // }
      form.append('current', this.page.page)
      form.append('pageSize', this.page.limit)
      form.append('CurrencyType', type)
      form.append('Type', '')
      form.append('MultiType', multiType)
      form.append('CurrencyId', this.form.bit)
      debtLog(form).then(res => {
        let list = res.data.Items.filter(v => {
          return v.Type != 1
        })
        if (res.data.Items) {
          if (isAdd) {
            this.dataList = this.dataList.concat(list)
          } else {
            this.dataList = list
          }
          this.totalPage = res.data.Pagination.totalPage
          if (this.totalPage <= this.page.page) {
             this.finished = true;
          }
        }
        this.isInit = true
        this.loading = false
      })
    },
    // 初始化划转记录
    initTransferLog(isAdd) {
      let form = new FormData()
      form.append('current', this.page.page)
      form.append('limit', this.page.limit)
      form.append('CurrencyId', this.form.bit)
      form.append('FromAccount', '')
      form.append('ToAccount', '')
      transferRecordLists(form).then(res => {
        let list = res.data.Items || []
        if (isAdd) {
          this.dataList = this.dataList.concat(list)
        } else {
          this.dataList = list
        }
        this.totalPage = res.data.Pagination ? res.data.Pagination.totalPage : 1
        if (this.totalPage <= this.page.page) {
           this.finished = true;
        }
        this.isInit = true
        this.loading = false
      }).catch(err => {
        // 如果新接口失败，回退到旧接口
        console.warn('新划转记录接口失败，使用旧接口:', err)
        let fallbackForm = new FormData()
        fallbackForm.append('current', this.page.page)
        fallbackForm.append('pageSize', this.page.limit)
        fallbackForm.append('CurrencyType', '')
        fallbackForm.append('Type', '')
        fallbackForm.append('MultiType', '2,3') // 划转记录类型
        fallbackForm.append('CurrencyId', this.form.bit)
        debtLog(fallbackForm).then(res => {
          let list = res.data.Items.filter(v => {
            return v.Type == 2 || v.Type == 3 // 只显示划转相关记录
          })
          if (isAdd) {
            this.dataList = this.dataList.concat(list)
          } else {
            this.dataList = list
          }
          this.totalPage = res.data.Pagination.totalPage
          if (this.totalPage <= this.page.page) {
             this.finished = true;
          }
          this.isInit = true
          this.loading = false
        })
      })
    },
    changeTab(i) {
      this.tabIndex = i
      this.page.page = 1
      this.form.type = i == 1 ? 4 : 17
      this.init()
    },
    back() {
      this.$router.go(-1)
    },
    getTypeName(item, name) {
      // 如果是划转记录页面且有FromAccount和ToAccount字段，显示划转信息
      if (this.pageType === 'transfer' && item.FromAccount && item.ToAccount) {
        return `${this.getAccountName(item.FromAccount)} → ${this.getAccountName(item.ToAccount)} (${name})`
      }

      let type = item.Type
      let index = this.typeList.findIndex(v => {
        return v.value == type
      })
      console.log("index", item)
      if (index > -1) {
        if (type == 9) {
          return this.i18n.t('assestLog.order') + "(" + name + ")"
        } else if (type == 6) {
          return this.i18n.t('assestLog.order') + "(" + name + ")"
        } else if (type == 7) {
          return this.i18n.t('assestLog.Sell') + "(" + name + ")"
        } else if (type == 11) {
          return this.i18n.t('assestLog.Settle') + "(" + name + ")"
        } else if (type == 2) {
          return this.i18n.t('transfer.label1') + "(" + name + ")" // 划转转出
        } else if (type == 3) {
          return this.i18n.t('transfer.label2') + "(" + name + ")" // 划转转入
        } else {
          return this.typeList[index].label+ "(" + name + ")"
        }
      } else {
        return name
      }
    },
    // 获取账户类型的显示名称
    getAccountName(accountType) {
      const accountMap = {
        'Capital': this.i18n.t('transfer.account1'),
        'Spot': this.i18n.t('transfer.account2'),
        'Contract': this.i18n.t('transfer.account3'),
        'Option': this.i18n.t('transfer.account4'),
        'Finance': this.i18n.t('transfer.account5'),
        'Follow': this.i18n.t('transfer.account6')
      }
      return accountMap[accountType] || accountType
    }
	}
}
</script>